<!--
 * @Description: answerPop.vue
-->
<script setup>
import { ref, defineProps, defineModel, watch } from "vue";
import { IonButton } from "@ionic/vue";
const props = defineProps({
  answerPopData: {
    type: Object,
    default: () => {},
  },
});
const answerPopShow = defineModel("show");
// answerPopShow.value = false
const closeAnswerPop = () => {
  answerPopShow.value = !answerPopShow.value;
  console.log(answerPopShow.value);
};
watch(
  () => answerPopShow.value,
  (newVal) => {
    console.log(props.answerPopData);
    if (newVal) {
      // document.getElementById("el-examination-option").innerHTML =
      //   props.answerPopData.option.outerHTML;
    }
    showAnswerVisible.value = false;
  }
);
const showAnswerVisible = ref(false);

function showAnswer() {
  showAnswerVisible.value = !showAnswerVisible.value;
  console.log(showAnswerVisible.value);
  // document.getElementById("elAnswer").innerHTML = props.answerPopData.answer;
}
</script>

<template>
  <div class="answerPop" :class="{ slide_out: !answerPopShow, slide_in: answerPopShow }">
    <div class="answerPopHeader">
      <img src="@/assets/answerPop_header.png" alt="" @click="closeAnswerPop" />
    </div>
    <div class="answerPopContent">
      <div id="el-examination-option" v-html="props.answerPopData?.option?.outerHTML"></div>
      <div class="answer-content">
        <ion-button color="success" @click="showAnswer">答案</ion-button>
        <span v-if="showAnswerVisible" id="elAnswer" v-html="props?.answerPopData?.answer"></span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.answerPop {
  position: absolute;
  //bottom: -300px;
  left: 0;
  width: 100%;
  height: 200px;
  z-index: 9999;
}
.answerPopHeader {
  width: 100%;
  height: 20px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  > img {
    height: 20px;
    width: auto;
  }
}
.answerPopContent {
  width: 100%;
  height: calc(100% - 20px);
  background-color: #fff;
  padding: 20px;
  overflow-y: auto;
}
.slide_in {
  transition: all 0.5s ease-in-out;
  bottom: 0;
}
.slide_out {
  transition: all 0.5s ease-in-out;
  bottom: -300px;
}
//.examination-option-table {
//  width: 100%;
//}
//.examination-option-table tr td:nth-child(1) {
//  width: 13%;
//}
//.examination-option-table tr td {
//  padding-bottom: 10px;
//  word-break: break-all;
//  max-width: 2.8rem;
//}
</style>
